import { Component, HostListener, QueryList } from "@angular/core";
import { TokenService } from "../../../../../auth/token.service";
import { Observable, of } from "rxjs";
import { SavingStateService } from "../../services/saving-state.service";
import * as _ from "lodash";
import { ToastService } from "../../../../../shared/toast.service";
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { DeviceCheckService } from "../../services/device-check.service";
import { SessionService } from "../../services/session.service";

@Component({
  template: ``,
})
export class SurveyAbstractComponent {
  protected surveyComponents: QueryList<any>;
  protected tabs;
  protected tabConfig;

  isAuthCanWrite: boolean;
  fullBlockAddress: string;
  names: string[];
  initials: string;

  @HostListener("window:beforeunload", ["$event"])
  beforeWindowUnload() {
    this.saveCurrentTab();
    return this.savingStateService.canDeactivateCheck();
  }

  get showTabTitle() {
    return (
      this.deviceCheckService.onLandscape() &&
      !this.deviceCheckService.widthCheck(1000)
    );
  }

  get onPC() {
    return this.deviceCheckService.onPC();
  }

  get address(): any {
    return;
  }

  get buildingKey(): any {
    return;
  }

  get addressTitle() {
    return `${this.fullBlockAddress} | ${this.address?.getFullAddress()} ${
      this.buildingKey ? " | " + this.buildingKey : ""
    }`;
  }

  constructor(
    protected tokenService: TokenService,
    protected savingStateService: SavingStateService,
    protected toastService: ToastService,
    protected deviceCheckService: DeviceCheckService,
    protected sessionService: SessionService
  ) {}

  getValidationError() {
    const error = _(this.tabConfig.tabs)
      .omit(["valRemarks", "validate"])
      .map(
        (tab, key) =>
          tab && this.surveyComponents.find((c) => c && c.tabId == key)
      )
      .map((x) => x?.getValidationError && x.getValidationError(true))
      .find((x) => !!x);

    return error;
  }

  saveCurrentTab = (): Promise<boolean> => {
    const func = this.getSaveFunction();
    return func?.toPromise();
  };

  navigateToTab(targetTabId: string): void {
    const activeTab = this.tabConfig.tabs[this.tabs.activeId];
    const targetTab = this.tabConfig.tabs[targetTabId];
    let nextTab = null;

    if (targetTab.index > activeTab.index)
      nextTab = _.find(this.tabConfig.tabs, ["index", targetTab.index + 1]);

    const func = this.getSaveFunction(activeTab, targetTab);
    this.handleChange(func, targetTab, nextTab);

    const activeTabComponent = this.surveyComponents.find(
      (c) => c.tabId == this.tabs.activeId
    );
    if (activeTabComponent && activeTabComponent.onTabOpenend)
      activeTabComponent.onTabOpenend();
  }

  onNavChange(e: NgbNavChangeEvent): void {
    this.navigateToTab(e.nextId);
  }

  protected enableValidatedTabs() {
    if (!this.getValidationError())
      Object.keys(this.tabConfig.tabs).forEach((i: string) => {
        this.tabConfig.tabs[i].disabled = false;
      });
  }

  protected getSaveFunction(activeTab: any = null, targetTab: any = null) {
    if (
      (activeTab && activeTab.readonly) ||
      ["valRemarks", "validate"].includes(this.tabs.activeId)
    )
      return of(true);

    const activeTabComponent = this.surveyComponents.find(
      (c) => c.tabId == this.tabs.activeId
    );
    if (activeTabComponent) return activeTabComponent.save(false);

    return of(true);
  }

  protected setBlockAddress() {
    this.fullBlockAddress = this.sessionService.getBlockAddress();
  }

  protected setInitials(names: string[]) {
    //["Jean-Claude", "Van Damme"]
    this.initials = names.reduce(
      (acc, fullName) =>
        acc +
        fullName
          ?.split(/[\s\-]+/)
          .map((n) => n.charAt(0).toUpperCase())
          .join(""),
      ""
    );
  }

  handleChange(
    saveFunc: Observable<boolean>,
    targetTab: any,
    nextTab: any
  ): void {
    if (this.isAuthCanWrite) {
      saveFunc.subscribe(
        (bool: boolean) => {
          this.selectNextTab(targetTab, nextTab);
          this.refreshValidateTab();
        },
        () => {}
      );
    } else {
      this.selectNextTab(targetTab, nextTab);
      this.refreshValidateTab();
    }
  }

  selectNextTab(targetTab: any, nextTab: any): void {
    targetTab.disabled = false;
    this.tabs.activeId = targetTab.id;
    this.tabs.select(targetTab.id);

    if (nextTab) nextTab.disabled = false;
  }

  refreshValidateTab() {
    this.tabConfig.tabs.validate.disabled = _(this.tabConfig.tabs)
      .omit("valRemarks", "validate")
      .some((x) => x.disabled);
  }
}
